<template>
  <div>
    <div v-if="!isHideUpload">
      <el-upload
        class="upload-demo"
        action
        :on-remove="handleRemove"
        multiple
        :show-file-list="isShowList"
        :before-upload="beforeUpload"
        :on-success="handleUploadSuccess"
        :on-error="handleUploadError"
        :http-request="upload"
        :on-exceed="handleExceed"
        :limit="limitCount"
        :file-list="explainFileList"
      >
        <el-button type="primary" :disabled="disabled">+{{ btnTxt }}</el-button>
      </el-upload>
      <span v-if="!_.isEmpty(fileTypes)" style="color: #999"
        >支持{{ fileTypes.join(",") }}格式，且大小不超过10MB</span
      >
      <span v-else style="color: #999"
        >支持doc、docx、xls、xlsx、ppt、pptx、pdf格式，且大小不超过10MB</span
      >
    </div>
    <div v-if="isShowFileList">
      <div
        class="file-box"
        v-for="(file, index) in explainFileList"
        :key="index"
      >
        <span class="file-box_name">{{ handleFileName(file.name) }}</span>
        <el-link
          icon="el-icon-download"
          class="file-box_down"
          :underline="false"
          @click="downloadFile(file)"
          >下载原文</el-link
        >
        <el-link
          style="color: #ff6c66"
          :underline="false"
          @click="removeFile(file, index)"
          v-if="!isHideFileDelete"
          >删除</el-link
        >
      </div>
    </div>
  </div>
</template>
<script>
import { uploadFile } from "@/api/common";
import { downFile } from "@/utils/tool";
export default {
  props: {
    //最新的文件 字符串列表
    upLoadFileList: {
      type: Array,
      default: () => []
    },
    //下载文件类型
    downFileType: {
      type: String,
      default: "application/msword"
    },
    //是否展示列表
    isShowList: {
      type: Boolean,
      default: false
    },
    //是否展示文件列表
    isShowFileList: {
      type: Boolean,
      default: true
    },
    //文件上传限制大小
    limitSize: {
      type: Number,
      default: 10
    },
    //是否禁用上传按钮
    disabled: {
      type: Boolean,
      default: false
    },
    //是否禁用删除按钮
    isHideFileDelete: {
      type: Boolean,
      default: false
    },
    //是否隐藏上传按钮
    isHideUpload: {
      type: Boolean,
      default: false
    },
    //文件上传数量 默认为1个
    limitCount: {
      type: Number,
      default: 1
    },
    //支持的文件类型
    fileTypes: {
      type: Array,
      default: () => []
    },
    btnTxt: {
      type: String,
      default: "上传附件"
    }
  },
  watch: {
    upLoadFileList: {
      handler(newVal, oldVal) {
        if (!newVal) return;
        if (_.isEmpty(newVal)) {
          this.explainFileList = [];
        } else {
          // 如果是字符串数组则需要处理成upload组件能识别的格式
          const newVals = _.map(newVal, item => {
            const newItem = {
              name: item.name ? item.name : item,
              url: item.url ? item.url : this.getSeverFileUrl(item),
              uid: item.uid ? item.uid : Number(_.uniqueId())
            };
            return newItem;
          });
          this.explainFileList = newVals;
        }
      },
      deep: true,
      immediate: true
    }
  },
  data() {
    return {
      explainFileList: [],
      baseFile: {}
    };
  },
  methods: {
    downloadFile(file) {
      //调用下载
      downFile(
        { urlStr: file.name }, // 后台需要的参数
        "/public/downloadUrlFile", // 路径
        this.downFileType, // 下载的文件类型
        file.name //下载文件名称
      );
    },
    //删除单个文件
    removeFile(file, index) {
      this.explainFileList.splice(index, 1);
      this.$emit("upFileKey", this.explainFileList, file);
    },
    //上传成功文件
    handleUploadSuccess(res, file, fileList) {
      if (res && !_.isEmpty(res.data.fileAddr)) {
        const curFile = {
          name: res.data.fileAddr[0],
          url: this.getSeverFileUrl(res.data.fileAddr[0]),
          uid: file.uid
        };
        this.explainFileList.push(curFile);
        this.$emit("upFileKey", this.explainFileList, curFile, {
          url: curFile.name,
          name: file.raw.name,
          type: file.raw.type
        });
        
        this.$emit("uploadSuccess", {
          url: curFile.name,
          name: file.raw.name,
          type: file.raw.type
        });
      }
      this.$modal.closeLoading();
    },
    handleRemove(file, fileList) {},
    // 文件大小限制
    handleExceed(files, fileList) {
      this.$modal.msg(`上传文件数量不能超过${this.limitCount}个`);
    },
    handleUploadError(err, file, fileList) {
      this.$modal.closeLoading();
      this.$modal.msgWarning("上传文件失败，请重试");
    },
    async upload(file) {
      const form = new FormData();
      form.append("files", file.file);
      this.$modal.loading("正在上传文件，请稍候...");
      const res = await uploadFile(form);
      if (res.code == 200) {
        file.onSuccess(res);
      }
    },
    beforeUpload(file) {
      let FileExt = file.name.replace(/.+\./, "");
      let flag = this.fileTypes.includes(FileExt);
      if (!flag && this.fileTypes.length > 0) {
        this.$modal.msgWarning("文件格式错误请重新上传!");
        return false;
      }
      const isLtSize = file.size / 1024 / 1024 < this.limitSize;
      if (!isLtSize)
        this.$modal.msgWarning(`上传的文件大小不能超过${this.limitSize}MB!`);
      return isLtSize;
    },
    //处理文件名称 截取最后一个下划线后的字符作为文件名,如果没有展示原来的文件名
    handleFileName(str) {
      // 使用正则表达式匹配最后一个下划线之后的所有字符
      const match = str.match(/_(.*)$/);
      return match ? match[1] : str;
    }
  }
};
</script>
<style lang="less" scoped>
.iconjr-icon-link {
  font-size: 12px;
}
.the-active {
  ::v-deep .el-button {
    color: #4da75b !important;
    padding: 11px 10px;
  }
  i {
    color: #4da75b !important;
  }
}
::v-deep .el-button {
  padding: 11px 10px;
}
.file-box {
  display: flex;
  align-items: center;
  &_name {
    display: inline-block;
    margin-right: 40px;
    color: #1f212b;
    max-width: 500px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  &_down {
    margin-right: 20px;
    color: #156fda;
  }

  ::v-deep .el-icon-download {
    color: #156fda;
    font-size: 18px;
  }
}
</style>
